import { IUpdateItemFolhaPagamentoVerbaUseCase } from "../../../presentation/useCases/update/update_item_folha_pagamento_verba_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateItemFolhaPagamentoVerbaUseCase
 */

export class UpdateItemFolhaPagamentoVerbaUseCase implements IUpdateItemFolhaPagamentoVerbaUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateItemFolhaPagamentoVerba(
    idItemFolhaPagamentoVerba: number,
    valorUnitario: number | null,
    quantidade: number | null,
  ): Promise<void> {
    await this.repository.updateItemFolhaPagamentoVerba(
      idItemFolhaPagamentoVerba,
      valorUnitario,
      quantidade,
    );
  }
}
